import * as React from 'react';
import { Dropdown } from 'react-bootstrap';

export type SortOptionsType = {
	value: string;
	label: string;
};

interface SortDropdownTypes {
	sortOptions: SortOptionsType[];
	selectedSortOption: SortOptionsType;
	setSelectedSortOption: React.Dispatch<React.SetStateAction<SortOptionsType>>;
	handleOnChange?: () => void;
	disabled?: boolean;
}

const SortDropdown: React.FC<SortDropdownTypes> = ({
	sortOptions,
	selectedSortOption,
	setSelectedSortOption,
	handleOnChange,
	disabled = false
}) => {
	return (
		<Dropdown className="sort-dropdown" onSelect={handleOnChange}>
			<Dropdown.Toggle variant="dropdown" disabled={disabled}>
				<span>{selectedSortOption.label}</span>
			</Dropdown.Toggle>
			<Dropdown.Menu>
				{sortOptions.map((item, index) => (
					<Dropdown.Item
						onClick={() => setSelectedSortOption(item)}
						key={index}
						as="button"
						active={selectedSortOption.value === item.value}
					>
						{item.label}
					</Dropdown.Item>
				))}
			</Dropdown.Menu>
		</Dropdown>
	);
};

export default SortDropdown;
